import React from "react";

class RequiredIcon extends React.Component {
    public render(): JSX.Element {
        return (
            <span className="mx-1 text-danger font-weight-bold" title={"Il campo è obbligatorio"}>
                {/* title={i18n.t("global_campo_obbligatorio")} */}*
            </span>
        );
    }
}

export { RequiredIcon as Unconnected };
export default RequiredIcon;
